import AntIcon from "@/components/icons/AntIcon";
import { StrikeDiagonal } from "@/components/StrikeDiagonal";
import { URLQuery } from "@/utils/queryUtils";
import { cssVariables } from "@/utils/utils";
import { Button, Popover, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router";
import { QueryKeys } from "../../../common/constants";
import { UUID } from "../../../typings/global";
import { CLIENT_ROUTE_PATHS } from "../paths";
import { ADD_ACCOUNT_QUERY_KEY, CLIENT_DETAIL_TAB } from "../utils";

type Props = {
  hasMobileApp?: boolean;
  clientId: UUID;
};

export const ClientMobileAppIndicator = ({ hasMobileApp, clientId }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      {hasMobileApp ? (
        <Tooltip title={t("client.helpers.hasMobileAppHint")}>
          <Button color="green" variant="outlined" icon={<AntIcon type="mobile" />} style={{ cursor: "auto" }} />
        </Tooltip>
      ) : (
        <Popover
          content={
            <div>
              <p>{t("client.helpers.hasNoMobileAppHint")}.</p>

              <Link
                to={
                  generatePath(`${CLIENT_ROUTE_PATHS.detail.to}`, { id: clientId }) +
                  URLQuery.searchParamsToString({
                    searchParams: { [QueryKeys.TAB]: CLIENT_DETAIL_TAB.ACCOUNTS, [ADD_ACCOUNT_QUERY_KEY]: true },
                  })
                }
              >
                <Button type="primary" size="small">
                  {t("client.actions.createAccount")}
                </Button>
              </Link>
            </div>
          }
          zIndex={0}
          placement="bottom"
        >
          <span>
            <StrikeDiagonal lineColor={cssVariables.colorRed}>
              <Button icon={<AntIcon type="mobile" />} color="red" variant="outlined" />
            </StrikeDiagonal>
          </span>
        </Popover>
      )}
    </div>
  );
};
